import React, { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

type Props = {
  value: string;
  width?: number;
  height?: number;
  fontSize?: number;
};

const BarcodeCanvas: React.FC<Props> = ({
  value,
  width = 1.5,
  height = 70,
  fontSize = 16,
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current && value) {
      JsBarcode(canvasRef.current, value, {
        format: "CODE128",
        displayValue: true,
        width,
        height,
        fontSize,
        margin: 0,
        fontOptions: "bold",
      });
    }
  }, [value]);

  return <canvas ref={canvasRef} />;
};

export default BarcodeCanvas;
